import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { i18n } from "./plugins/i18n";
import VueCookies from "vue-cookies";
// @ts-ignore
import Masonry from "@/plugins/masonry";
import VueSocialSharing from "vue-social-sharing";
import VueTour from "vue-tour";
import VueMeta from "vue-meta";
//Import Froala Editor
import "froala-editor/js/plugins.pkgd.min.js";
//Import third party plugins
import "froala-editor/js/third_party/embedly.min";
import "froala-editor/js/third_party/font_awesome.min";
import "froala-editor/js/third_party/spell_checker.min";
import "froala-editor/js/third_party/image_tui.min";
// Import Froala Editor css files.
import "froala-editor/css/froala_editor.pkgd.min.css";

// Import and use Vue Froala lib.
// @ts-ignore
import VueFroala from "vue-froala-wysiwyg";

require("vue-tour/dist/vue-tour.css");

Vue.use(VueFroala);
Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.use(Masonry);
Vue.use(VueSocialSharing);
Vue.use(VueMeta);

//@ts-ignore
Vue.use(VueTour);

export const bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h: (arg0: any) => any) => h(App)
}).$mount("#app");
